import { LanguageDetectorModule } from 'i18next'

const EN = 'en'
const RU = 'ru'
const DEF = RU

export const LANGS = [EN, RU]

let lang: string = DEF

function fixLang(lang: string | undefined): string {
  const good = lang && LANGS.includes(lang)
  return good ? lang : DEF
}

export function setLang(value: string | undefined) {
  lang = fixLang(value)
}

export function getLang(): string {
  return lang
}

export class LanguageDetector implements LanguageDetectorModule {
  readonly type = 'languageDetector' as const

  detect() {
    return lang
  }
}
